// extracted by mini-css-extract-plugin
export default {"root":"spUNgev6"};